exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p.page-spacer {\n  margin-top: 100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/admin-area/containers/dashboard-page/dashboard-page.scss
// module id = ../../../../../src/app/admin-area/containers/dashboard-page/dashboard-page.scss
// module chunks = main